import React from 'react';

import PasswordManager from './PasswordManager';

const CreatePassword = () => <PasswordManager type="create" />;

export default CreatePassword;
